var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-stack",style:({ top: _vm.$vuetify.application.top + 'px' })},[_c('SafetyAlertBanner'),_c('BlockedQuestBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }